import { useChannels } from '@/hooks/api/useChannels';
import { Link } from 'react-router-dom';
import { SpriteSvg } from '@/components/common/SpriteSvg';

export const Menu = () => {
  const { data: channels } = useChannels();

  return (
    <>
      <input type="checkbox" className="opener-checkbox" id="menu-opener" />
      <nav>
        <label className="backdrop" htmlFor="menu-opener"></label>
        <div className="container">
          <div className="header">
            <label htmlFor="menu-opener">
              <SpriteSvg name={'icon-menu-close'} className={'i'} />
            </label>
          </div>
          <div className="body">
            <div className="menu-wrapper channels">
              <div className="title">
                <SpriteSvg name={'icon-creator'} className={'i'} />
                Channel
              </div>
              {channels?.map((c) => (
                <Link key={`menu_${c.id}`} to={`/channels/${c.cid}`}>
                  <img src={c.icon_url} className="icon" />
                  <span>{c.name}</span>
                </Link>
              ))}
            </div>
            <div className="menu-wrapper">
              <div className="title">
                <SpriteSvg name={'icon-flag'} className={'i'} />
                関連サイト
              </div>
              <a href="https://www.cityheaven.net/">シティヘブンネット</a>
            </div>
            <div className="menu-wrapper">
              <div className="title">
                <SpriteSvg name={'icon-other'} className={'i'} />
                その他
              </div>
              <a href="https://www.cityheaven.net/tokyo/sitepolicy/" className="sm">
                プライバシーポリシー
              </a>
              <a href="https://www.cityheaven.net/tokyo/ACUserToiawase/" className="sm">
                お問い合わせ
              </a>
            </div>
            <div className="copyright">
              &copy;CityHeaven.net
              <br />
              Powered by{' '}
              <a href="https://knip.jp" className="copyright">
                KNIP
              </a>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};
